import { schemes } from "@zeal/common";
import { z } from "zod";

export const postGenerateInvoicePaymentLinkSchema = z.object({
  companyID: schemes.uuid(),
  invoiceID: schemes.uuid(),
  customerAccountID: schemes.uuid(),
  send_to_admin: z.boolean().optional(),
});

export type TPostGenerateInvoicePaymentLinkRequest = z.infer<
  typeof postGenerateInvoicePaymentLinkSchema
>;
